import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import './lib/i18n/i18n'
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react'
import { msalInstance } from './auth/mintAuthenticationProvider'
import { InteractionType, PublicClientApplication } from '@azure/msal-browser'
import { isTestMode } from './testMode'
import { getAppInsights } from './lib/appinsights/config'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { AppInsightsProvider } from './provider/AppInsightsProvider'
import { AuthErrorBoundary } from './auth/AuthErrorBoundary'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

const renderUnprotectedApp = () => {
  root.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  )
}

const handleRedirect = (msalApplication: PublicClientApplication) => {
  msalApplication.handleRedirectPromise()
    .catch(error => {
      console.error('MSAL redirect error handling:', error)
    })
}

const setActiveAccountIfAvailable = (msalApplication: PublicClientApplication) => {
  const accounts = msalApplication.getAllAccounts()
  if (accounts.length > 0) {
    msalApplication.setActiveAccount(accounts[0])
  }
}

const renderMsalProtectedApp = (appInsights: ApplicationInsights | null) => {
  msalInstance().then((msalApplication: PublicClientApplication) => {

    handleRedirect(msalApplication)
    setActiveAccountIfAvailable(msalApplication)

    return root.render(
      <React.StrictMode>
        <MsalProvider instance={msalApplication}>
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}
            errorComponent={AuthErrorBoundary}
          >
            {appInsights ? (
              <AppInsightsProvider appInsights={appInsights}>
                <App/>
              </AppInsightsProvider>
            ) : (
              <App/>
            )}
          </MsalAuthenticationTemplate>
        </MsalProvider>
      </React.StrictMode>
    )
  }).catch(error => {
    console.error('MSAL initiation failed:', error)
  })
}

if (isTestMode()) {
  renderUnprotectedApp()
} else {
  getAppInsights().then(instance => {
    if (instance) {
      instance.loadAppInsights()
      renderMsalProtectedApp(instance)
    } else {
      renderMsalProtectedApp(null)
    }
  }).catch(error => {
    console.error('AppInsights initiation failed:', error)
    renderMsalProtectedApp(null)
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
